import usePath from '../../../../components/Hooks/usePath';
import { FeatureFlagEnum } from '../../../../featureflag/feature-flag.enum';
import useDataQuery from '../../../../hooks/useDataQuery/useDataQuery';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import useSearchParams from '../../../../hooks/useSearchParams';
import PATHS from '../../../../routes/routes.const';
import { orderTotalsRepositoryOfflineAdapters } from '../../../offline/offlineRequestAdapters/orderTotals.repository.offlineAdapters';
import { formatOrderFilters } from '../../orderFilter/orderFilter.utils';
import { getOrderTotalsQueryKey } from './order-totals.keys';
import { getOrderTotals } from './order-totals.repository';
import { OrderListTotals, UseGetOrderTotalsParams } from './order-totals.types';

export const useGetOrderTotals = ({
  isOfflineMode,
  enabled = true,
}: UseGetOrderTotalsParams = {}) => {
  const { searchParams } = useSearchParams();
  const { isPath } = usePath();
  const isOrderListPath = isPath(PATHS.main.orders.path);

  const { getFeatureFlag } = useFeatureFlag();
  const isOrdersTotalsEnabled = getFeatureFlag(FeatureFlagEnum.ORDERS_TOTAL, false);

  const formattedSearchParams = isOfflineMode
    ? { isOfflineMode: true }
    : formatOrderFilters({ ...searchParams, order: undefined });

  const queryFn = async () => {
    const response = isOfflineMode
      ? await orderTotalsRepositoryOfflineAdapters.getOrderTotals()
      : await getOrderTotals(formattedSearchParams);

    if (!response.ok || !response.data) {
      throw new Error('Error fetching order totals');
    }

    return response.data;
  };

  return useDataQuery<OrderListTotals[]>(
    {
      queryKey: getOrderTotalsQueryKey(formattedSearchParams),
      queryFn,
      refetchOnMount: true,
      gcTime: 0,
      keepPreviousData: true,
    },
    {
      enabled: isOrdersTotalsEnabled && isOrderListPath && enabled,
    },
  );
};
